import { useState, useEffect } from 'react';
import { Grid, makeStyles, Typography, Link } from "@material-ui/core";
import UtilService from "../../../../../../../../helper/service";
import roles from '../../../../../../../../helper/roles';
import { useHistory } from 'react-router';


interface IProps {
    participantsStatus: any;
  }


  const ParticipantCount = (props: IProps) => {
    const classes = useStyles();
    const history = useHistory();
    const { participantsStatus } = props;

    const [commentary, setCommentary] = useState("Analyzing...");

  

    useEffect(() => {
        if (!!participantsStatus) {
          
            if (participantsStatus?.completed >= 35 && participantsStatus?.completed < 45) {
                setCommentary("This is a solid participant count.  You will want at least 35 completed measurements to have a robust and repeatable prediction.  Seems like you are in good shape.");
            } else if (participantsStatus?.completed >= 25 && participantsStatus?.completed < 35) {
                setCommentary(`You might consider adding a few more brains to this test.  With only a handful more people, you can increase your confidence in this result.`);
            } else if (participantsStatus?.completed >= 10 && participantsStatus?.completed < 25) {
                setCommentary(`Pretty good sample.  Depending on the demographic breakdown, this group should give you a good directional sense of how this content will perform in market.`);
            } else if (participantsStatus?.completed < 10) {
                setCommentary(`With a sample size of ${participantsStatus?.completed} you should consider this a first step. The data in this result will give you some good direction, but you will want a sample size greater than 35 brains to gain confidence.`);
            } else if (participantsStatus?.completed > 45) {
                setCommentary(`Sweet! A sample size of ${participantsStatus?.completed} is going to give you strong results. Have you tagged the participants with demographic data to see how subgroups may respond?`);
            }  

        }
      }, [props]);
    

      const goToSetup = () => {
        
        const currentSessionCode = localStorage.getItem("session_code") ? localStorage.getItem("session_code") : "";
        const userData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : "";
        let url = `/creator/experience-manager/participants/${currentSessionCode}`;
        if (!!userData) {
          if (UtilService.checkTrialAccess(userData, roles['trial']['experiences'])) {
            url = `/subscriber/creator/experience-manager/participants/${currentSessionCode}`;
          }
        }
        history.push(url, { session_id: localStorage.getItem("session_id") ? localStorage.getItem("session_id") : "" });
      };
    


    return (

        <Grid item xs={4} style={{textAlign: 'center'}}>
            <Typography variant="h1" color={'primary'} className={classes.itemtitle}>{!!participantsStatus ? participantsStatus.completed : "0"}</Typography>
            <Typography variant="body1" className={classes.sectionTitle}>Participant Count</Typography>
            <Typography variant="body1" className={classes.bodyText}>{commentary}</Typography>
            <Link className={classes.actionLink} onClick={goToSetup}>
                <Typography variant="body1" className={classes.foo}>Review the Participants</Typography>
            </Link>
          </Grid>

    )


  }

  export default ParticipantCount;

  const useStyles = makeStyles(() => ({
    root: {
      paddingTop: 0,
      '@media (max-width: 600px)': {
        paddingTop: 0,
      },
    },
    itemtitle: {
        fontSize: 90,
        fontFamily: 'Spartan-bold',
        marginBottom: -30,
    },
    actionLink: {
      cursor:'pointer',
      //color: '#6667ab',
    },
    subtitle: {
        fontSize: 24,
        color: '#cccccc'
    },
    bodyText: {
        color: '#697683',
        fontFamily: 'roboto-light',
    },
    sectionTitle: {
      fontSize: 16,
      fontFamily: 'roboto-bold',
      color: '#697683'
    },
    typeTitle: {
      fontSize: 24,
      fontFamily: 'Spartan-bold',
      color: '#697683',
      textAlign: 'center',
    },
    titleSection: {
      maxWidth: 500,
      display: 'flex',
      alignItems: 'center'
    },
    numberTitle: {
      marginTop: 5,
      fontSize: 29,
      minWidth: 60,
      textAlign: 'center',
      fontFamily: 'Spartan-extrabold',
      padding: '0 15px',
      '@media screen and (max-width: 600px)': {
        fontSize: 30
      }
    },
    title: {
      minWidth: 146,
      marginTop: 5,
      fontSize: 20,
      fontFamily: 'Spartan-bold',
      letterSpacing: '2px',
      textTransform: 'uppercase',
      '@media screen and (min-width: 331px) and (max-width: 600px)': {
        fontSize: 20
      },
      '@media screen and (max-width: 330px)': {
        fontSize: 18
      }
    },
    titleIcon: {
      width: 42,
      height: 42,
      '@media screen and (min-width: 331px) and (max-width: 600px)': {
        width: 35,
        height: 35
      },
      '@media screen and (max-width: 330px)': {
        width: 30,
        height: 30
      }
    },
    cardSection: {
      borderRadius: 20,
      background: '#fff',
      boxShadow: "0 8px 40px -12px rgba(0,0,0,0.3)"
    },
    pdfCardSection: {
      borderRadius: 20,
      background: '#fff',
      border: '1px solid rgba(0, 0, 0, 0.1)',
    },
    foo:{}
  }));